import { memo } from 'react'
import { Tooltip, Typography } from 'antd'
import dayjs from 'dayjs'
import { ETAT_DEMANDE_COLOR } from '../../constants'
import { D4_Fn_View_Demande } from '../../types'

export const Bat = memo(({ value }: { value: string }) => (
  <Tooltip placement="topLeft" title={value}>
    <Typography.Text style={{ width: '100%' }}>{value}</Typography.Text>
  </Tooltip>
))

export const Equipement = memo(({ value }: { value: string }) => (
  <Tooltip placement="topLeft" title={value}>
    <Typography.Text style={{ width: '100%' }}>{value}</Typography.Text>
  </Tooltip>
))

export const DateEvt = memo(({ value }: { value: string }) => (
  <Tooltip placement="topLeft" title={dayjs(value).format('DD MMMM YYYY')}>
    {dayjs(value).format('MM/YY')}
  </Tooltip>
))

export const Etat = memo(({ value, item }: { value: string; item: D4_Fn_View_Demande }) => (
  <Tooltip placement="topLeft" title={value}>
    <Typography.Text style={{ color: ETAT_DEMANDE_COLOR[item.couleuretatkanban ?? -1] ?? -1 }}>{value}</Typography.Text>
  </Tooltip>
))

export const Numero = memo(({ value }: { value: number }) => (
  <Typography.Text type="secondary">{value}</Typography.Text>
))
